const Button = ({
    title,
    isDisabled = false,
    onClick,
    type = "button",
}: {
    title: string;
    isDisabled: boolean;
    onClick?: () => void;
    type: "button" | "submit"
}) => {
    return <button 
        className={`${isDisabled ? "bg-gray-300 text-white" : "bg-black text-white"} border p-2 rounded-xl h-[calc(60px)] w-full`}
        type={type}
        disabled={isDisabled}
        onClick={isDisabled ? () => null : onClick}>
        {title}
    </button>;
}

export default Button;